import React from 'react';

import style from './intro.module.scss';

export const Intro = () => {
    return (
        <div className={style.intro}>
            <div className={style.introGroup}>
                <p className={style.introTitle}>High Performance Products for Demanding Environments</p>

                <p className={style.introContent}>
                    Teflon® encapsulated o-rings and spring energized seals offer many performance benefits in
                    demanding environments. FEP and PFA Teflon® fluoropolymer shell delivers excellent chemical
                    resistance with the energizing resiliency of a rubber elastomer core combines the best of both
                    materials for o-rings with extreme chemical and temperature resistance.
                </p>

                <p className={style.introContent}>
                    Teflon® encapsulated o-rings are more stiff than solid rubber so can require special groove design
                    considerations for optimal performance.&nbsp;
                    <span className={style.underLine}>Contact our responsive experts for engineering support.</span>
                </p>

                <p className={style.introContent}>
                    Wintech Seals has many commonly used sizes of Teflon® encapsulated o-rings in-stock, and custom
                    sizes are made within a few weeks without tooling fees.
                </p>

                <div className={style.commonApplications}>Common Applications</div>

                <div className={style.application}>
                    <div className={style.applicationList}>
                        <ul>
                            <li>Valve Stems</li>
                            <li>Flanges</li>
                            <li>Pumps</li>
                            <li>Swivels</li>
                        </ul>
                    </div>

                    <div className={style.applicationList}>
                        <ul>
                            <li>Turbo Pumps</li>
                            <li>Joints</li>
                            <li>Turbo Expanders</li>
                            <li>Cryogenic seals</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};
